import config from '../../helpers/config';

export default () => (location.href = config.externalCartUrl);
